namespace SPA{
	export namespace Contacts
	{
		export class Autocomplete
		{
			private Input: JQuery;
			private ObjectNumber: string;
			private Type: IContactStatusName;
			private Callback: ((data: SPA.ContactStatus|SPA.Contact) => void) | undefined;
			private When: string;

			public constructor(input: HTMLInputElement|JQuery, object_number: string, callback?: (data: SPA.ContactStatus|SPA.Contact) => void, when: string = 'afterLink')
			{
				this.Input = $(input);
				this.ObjectNumber = object_number;
				this.Type = this.Input.data('type') || '';
				this.Callback = callback;
				this.When = when;

				this.initAutocomplete();
			}

			public el(): JQuery
			{
				return this.Input;
			}

			private initAutocomplete()
			{
				this.Input.autocomplete({
					source: this.source,
					minLength: 2,
					select: (request, response) => this.select(request, response),
				});
			}

			private source(request, response)
			{
				const term = request.term.toLowerCase();

				const matches: SPA.Contact[] = app.getContactManager().search(term);
				const results = [];
				for (const match of matches) {
					results.push({
						data: match,
						value: '',
						label: match.getSalutationMapped() + ' ' + match.Name + " " + match.Surname + ", " + match.Street + " " + match.PostalCode
						// 	label: '#' + match.ContactID + ' | ' + match.getSalutationMapped() + ' ' + match.Name + " " + match.Surname + ", " + match.Street + " " + match.PostalCode
					});
				}

				response(results);
			}

			private select(event, ui)
			{
				(event.target as HTMLInputElement).value = "";
				const contact: SPA.Contact = ui.item.data;

				if (this.Callback && this.When === 'beforeLink')
				{
					return this.Callback(contact);
				}

				contact.link(this.ObjectNumber, this.Type, this.Callback);
			}
		}
	}
}
